import React, { useEffect, useState } from 'react';
import LoanSwitchBox from './LoanSwitchBox';
import { Button, Col, Popover, Row } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';
import { DownloadOutlined } from '@ant-design/icons';
import {
  downloadDocuments,
  downloadDocumentsUnzip,
  handleDownload,
  objToArray,
} from '../../common/Utilities';
import { ServerAPI } from '../../common/ServerAPI';
import axios from 'axios';
import {
  API,
  Endpoints,
  IMAGE_BASE_URL,
  serverUrl,
} from '../../common/Constants';
import DocumentPreview from './DocumentPreview';
import {
  UploadOutlined,
  FilePdfOutlined,
  FileWordOutlined,
  FileZipOutlined,
} from '@ant-design/icons';

const DownloadDocuments = () => {
  const location = useLocation();
  const [documentName, setDocumentName] = useState('');
  const [documentPreview, setDocumentPreview] = useState(false);
  const [documentUrl, setDocumentUrl] = useState('');
  const [fileDocumentType, setFileDocumentType] = useState('');
  const type = location.state.type;
  let documents = location.state.documents;
  console.log(documents);
  if (Array.isArray(documents) == false) {
    documents = objToArray(documents);
  }
  console.log(documents);
  const navigate = useNavigate();
  const [downloadPopOver, setDownloadPopOver] = useState(false);
  const hide = () => {
    setDownloadPopOver(false);
  };
  const handleOpenChange = (newOpen) => {
    setDownloadPopOver(newOpen);
  };

  const tabs = [];
  for (const obj of documents) {
    const key = Object.keys(obj)[0]; // Get the first (and only) key from the object
    let words = key.split('_');
    // Capitalize the first letter of each word and join them back together
    for (let i = 0; i < words.length; i++) {
      words[i] = words[i].charAt(0).toUpperCase() + words[i].slice(1);
    }
    let result = words.join(' ');
    if (result.length <= 4) {
      result = result.toUpperCase();
    }
    tabs.push({
      dataKey: key,
      name: result,
    });
    console.log(tabs);
  }

  const iconMap = {
    pdf: <FilePdfOutlined />,
    docx: <FileWordOutlined />,
  };

  const fileType = (url) => {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    const documentExtensions = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
    const lastDotIndex = url.lastIndexOf('.');
    if (lastDotIndex !== -1) {
      const fileExtension = url.slice(lastDotIndex + 1);
      if (imageExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType('Image');
      } else if (documentExtensions.includes(fileExtension.toLowerCase())) {
        setFileDocumentType('Document');
      }
    }
  };

  return (
    <div className='w-full min-h-screen bg-[#F5F5F5] overflow-x-clip'>
      <div className='bg-white'>
        <Row gutter={[24, 24]} className='p-[18px_25px]'>
          <Col xs={24} sm={12} md={24} lg={24}>
            <div className='text-[18px] font-[700] bg-white flex'>
              <div
                className='mt-1 min-[768px]: mr-5 max-[768px]:mr-1 cursor-pointer'
                onClick={() => navigate(-1)}
              >
                <img src='/images/left-circle.svg' alt='arrow' />
              </div>
              <p>{type.charAt(0).toUpperCase() + type.slice(1)} Documents</p>
            </div>
          </Col>
        </Row>
      </div>
      <div
        className='app-detail-tab-content mx-5 mt-5 p-5'
        style={{ maxHeight: '100%' }}
      >
        <div className='flex justify-between items-center mb-2'>
          <p className='text-[15px] font-[600]'>Document(s) Uploaded </p>
          <Popover
            content={
              <div>
                <Button
                  type='primary'
                  onClick={() => {
                    downloadDocuments(type);
                  }}
                  className='min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px] mb-2'
                >
                  <FileZipOutlined className='mr-2 mt-1' />
                  <p>Download Zip</p>
                </Button>
                <Button
                  type='primary'
                  onClick={() => {
                    downloadDocumentsUnzip(type);
                  }}
                  className='min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex w-[155px]'
                >
                  <DownloadOutlined className='mr-2 mt-1' />
                  <p>Download Files</p>
                </Button>
              </div>
            }
            placement='bottom'
            trigger='hover'
            open={downloadPopOver}
            onOpenChange={handleOpenChange}
          >
            <Button className='text-[#0F59F9] border border-[#0F59F9] min-[768px]:text-[14px] max-[768px]:text-[12px] bg-white flex'>
              <DownloadOutlined className='mr-2 mt-1' />
              <p>Download All</p>
            </Button>
          </Popover>
        </div>
        <LoanSwitchBox tabs={tabs} handler={setDocumentName} />

        {documents !== undefined &&
          documents.length > 0 &&
          documents.map((doc) => {
            const key = Object.keys(doc)[0];
            const value = doc[key];

            if (key === documentName) {
              return (
                <Row gutter={[16, 16]} className='mb-1 mt-4' key={key}>
                  {value.map((data) => (
                    <Col key={data}>
                      <div className='sm:w-2/2 lg:w-4/4 mt-1 flex border rounded py-2 w-full px-2'>
                        <img
                          style={{ width: '15px', height: '15px' }}
                          className='mr-3 mt-[2px]'
                          src={IMAGE_BASE_URL + data}
                        />
                        <div className='w-full flex'>
                          <div className='text-[13px] font-[500] text-[#0D062D]'>
                            {data.split('/').pop()}
                          </div>
                        </div>
                      </div>
                      <div className='w-full flex justify-between items-center mt-1'>
                        <p className='text-left font-lato text-[12px] text-[500] text-instruction-grey opacity-60 mt-1'></p>
                        <div className='text-right'>
                          <img
                            src={'/images/document_download.png'}
                            alt='Download Document'
                            className='max-w-xs cursor-pointer'
                            onClick={() => {
                              setDocumentPreview(true);
                              setDocumentUrl(data);
                              fileType(data);
                              // DownloadDocumentFile();
                            }}
                          />
                        </div>
                      </div>
                    </Col>
                  ))}
                  <DocumentPreview
                    open={documentPreview}
                    close={() => {
                      setDocumentPreview(false);
                    }}
                    title={
                      type.charAt(0).toUpperCase() + type.slice(1) + 'Document'
                    }
                    url={documentUrl}
                    type={fileDocumentType}
                  />
                </Row>
              );
            }

            return null; // Render nothing if the condition isn't met
          })}
      </div>
    </div>
  );
};

export default DownloadDocuments;
